import { Injectable, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ClockStatus } from '../../../../features/calendar/calendar-types';
import { ClockData } from '../../../../shared/data-types/shared-time-block-types';
import { CronJobsService } from '../../cron-jobs.service';

@Injectable({
  providedIn: 'root',
})
export class SharedClockHandlerService {
  public clockStartedAt: number | null = null;
  public clockInitialSeconds = 0;
  // Used for updating the sidebar.
  public activeClockChanged$ = new BehaviorSubject<ClockData | null>(null);
  private tickClockJob: string | null = null;

  // DI
  private readonly cronJobsService = inject(CronJobsService);

  public set setClockStart(newClockStart: number) {
    this.clockStartedAt = newClockStart;
  }

  public startClock(clockStartedAt: number): void {
    // Don't start clocks multiple times.
    if (this.tickClockJob) {
      return;
    }

    this.tickClockJob = this.cronJobsService.registerJob(this.emitClock.bind(this), 1000);
    this.clockStartedAt = clockStartedAt;
    this.emitClock();
  }

  public getCurrentTimerSeconds(): number {
    if (this.clockStartedAt === null) {
      return this.clockInitialSeconds;
    }

    const elapsedSeconds = Math.floor((Date.now() - this.clockStartedAt) / 1000);
    return this.clockInitialSeconds + elapsedSeconds;
  }

  public emitClock(seconds = null, clockStatus = ClockStatus.IsTicking): void {
    let timerSeconds = seconds;
    if (typeof seconds !== 'number' || !Number.isFinite(seconds)) {
      timerSeconds = this.getCurrentTimerSeconds();
    }
    this.activeClockChanged$.next([timerSeconds, clockStatus]);
  }

  public resetClock(): void {
    // Nothing to do.
    if (this.tickClockJob === null) {
      return;
    }

    this.cronJobsService.deregisterJob(this.tickClockJob);
    this.tickClockJob = null;
    this.emitClock(0, ClockStatus.NotTicking);
    this.clockInitialSeconds = 0;
    this.clockStartedAt = null;
  }
}
